import { render, staticRenderFns } from "./DisplayDoctors.vue?vue&type=template&id=b1b83546"
import script from "./DisplayDoctors.vue?vue&type=script&lang=js"
export * from "./DisplayDoctors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports